(function () {
    'use strict';

    function searchService() {

        function getAttributes(predicates) {
            var attributes = [];
            for (var key in predicates) {
                var predicate = predicates[key];
                var value = predicate.value;

                var isNumber = !isNaN(parseFloat(value)) && isFinite(value);
                var isBool = typeof value === "boolean";
                var isArray = Array.isArray(value);
                if (predicate.watch != undefined) {
                    if (value && predicate.watch(value)) {
                        if (isNumber) {
                            attributes.push(processPredicate(key, predicate));
                        } else if (isBool) {
                            attributes.push(processPredicate(key, predicate));
                        } else if (isArray) {
                            predicate.value = predicate.value.join(',');
                            attributes.push(processPredicate(key, predicate));
                        } else if (value.length > 0) {
                            attributes.push(processPredicate(key, predicate));
                        }
                    }
                }
            }
            return attributes;
        }

        function processPredicate(key, predicate) {
            return {
                'Name': key,
                'Value': predicate.value
            };
        }

        return {
            getAttributes: getAttributes
        }
    }

    searchService.$inject = [];

    angular.module('ecap.common').service('searchService', searchService);
})();